import { Directive, EmbeddedViewRef, Input, OnChanges, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appLet]'
})
export class LetDirective implements OnChanges {
  @Input('appLet') appLet: any;

  private embeddedViewRef: EmbeddedViewRef<any>;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

  ngOnChanges() {
    if (this.embeddedViewRef) {
      this.embeddedViewRef.context.$implicit = this.appLet;
    } else {
      this.embeddedViewRef = this.viewContainer.createEmbeddedView(this.templateRef, {
        $implicit: this.appLet
      });
    }
  }
}
